export default "__VITE_ASSET__CHojTQ6$__"